import _ from 'lodash';

import ValueNode from '../../ValueNode';
import Type from '../../../Type';
import config from '../../../utils/config';

import type Context from 'src/Context';
import type { BaseExpression, Expression } from '../../../types';

export interface GreaterThanNodeT extends BaseExpression {
    $type: 'GreaterThanNode';
    value: [Expression, Expression];
}

export default class GreaterThanNode extends ValueNode<GreaterThanNodeT> {
    static TYPE = Type.NTuple(
        { key: 'a', type: 'ValueNode', suggestions: 'number' },
        { key: 'b', type: 'ValueNode', suggestions: 'number' },
    );

    static uiConfig = {
        ...config.presets.comparison,
    };

    async execute(context: Context): Promise<any> {
        const source = await context.evaluate(this.expression.value[0]);
        const target = await context.evaluate(this.expression.value[1]);
        return _.isFinite(source) && _.isFinite(target) && source > target;
    }
}
